<template>
  <div class="surface-post-moderation">
    <div v-if="!canIModerate" class="post-moderation-message">
      <div v-if="isBeingEdited" v-t>Requires approval</div>
      <div v-else v-t>Awaiting approval</div>
    </div>
    <div v-if="canIModerate" class="post-moderation-actions button-list">
      <button class="button flat-button-inverse action-delete" @click="deletePost" v-t:title="'Delete'" v-t>
        Delete
      </button>
      <button class="button flat-button action-approve" @click="approve" v-t:title="'Approve'" v-t>Approve</button>
    </div>
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { mapActions } from 'vuex'
import IntlMixin from 'vuemixins/intl_mixin'
export default {
  mixins: [IntlMixin],
  props: ['post', 'canIModerate', 'isBeingEdited'],
  methods: {
    deletePost() {
      this.$emit('delete')
    },
    approve() {
      this.$emit('approve')
    },
  },
}
</script>

<style lang="scss" scoped>
@import './../../assets/stylesheets/3/modules/all';
.surface-post-moderation {
  background-color: $highlight-color;
  display: block;
}

.post-moderation-actions {
  padding: 8px;
  justify-content: flex-end;
}

.post-moderation-message {
  min-height: 32px;
  padding: 8px 16px;
  font-size: $small-font-size;
  color: $caption-text-color;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>
